<template>
  <div class="LightingOverview">
    <Title firstName="照明概况" lastName="HVAC OVERVIEW" />
    <div class="echarts">
		<div class="state sa"  >
			<div class="title">照明月用电</div>
			<div class="num">{{Number(getbuildPowerArr.find(item =>item.building.id == getBuildId).itemPower['照明']).toFixed(2)}}</div>
			<span>kWh</span>
		</div>
		<div class="state"  >
			<div class="item">
				<div class="title">办公区照度</div>
				<div class="num">--<span>LUX</span></div>
			</div>
			<div class="item">
				<div class="title">休息区照度</div>
				<div class="num">--<span>LUX</span></div>
			</div>
			<div class="item">
				<div class="title">走廊照度</div>
				<div class="num">--<span>LUX</span></div>
			</div>
		</div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
const Title = () => import("../../../../components/title/Title");
export default {
	inject:['buildId','floorId','buildPowerArr'],
	data() {
		return {
		};
	},
	components: {
		Title,
	},
	computed:{
        getBuildId(){
			return this.buildId()
		},
        getFloorId(){
			return this.floorId()
		},
		getbuildPowerArr(){
            return this.buildPowerArr()
        }
    },
};
</script>

<style lang="less" scoped>
.LightingOverview {
	width: 20vw;
	position: fixed;
		top: 68vh;
		right: 1vw;
		z-index: 1;
	.echarts {
		overflow: hidden;
		position: relative;
		height: 25vh;
		padding-bottom: 1vh;
		background: linear-gradient(
		0deg,
		rgba(0, 33, 59, 0.6) 0%,
		rgba(3, 13, 24, 0.7) 100%
		);
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		// align-items: center;
		
        
        .state{
            height: 7vh;
			padding-top: 2vh;
			width: 100%;
            display: flex;
            justify-content: space-evenly;
			padding-left: 1vw;
            align-items: center;
            color: rgba(230,243,253,0.7);
            .item{
                text-align: center;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;

                .title{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                }
                .num{
                    font-size: 20rem;
                    font-family: zcoolqingkehuangyouti;
                    color: #00DEFF;
                    &>span{
                        font-size: 14rem;
                    }
                }
            }
        }

		.sa{
			position: relative;
            padding: 0 2vw 0 1vw;
			padding-top: 0vh;
            font-size: 16rem;
			&::before{
				content:'';
				width: 18vw;
				height: 1px ;
				background-color: rgba(230,243,253,0.3);
				position: absolute;
				bottom: -3vh;
				left: 1vw;
			}
            
            .num{
                width: 120rem;
                height: 120rem;
                background:url('../../../../assets/img/yuanlt.png') no-repeat;
                background-size: 100% 100%;
                text-align: center;
                line-height: 120rem;
                font-family: zcoolqingkehuangyouti;
                font-size: 20rem;
                color: #00DEFF;
            }
		}

		.bottom {
		width: 20vw;
		height: 1vh;
		background: url(../../../../assets/img/板块装饰线.png) no-repeat;
		block-size: 100% 100%;
		position: absolute;
		bottom: 0;
		left: 0;
		}
	}
}
</style>
